import styled from 'styled-components';

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CircularProgressContainer = (styled.div<{ size: number }>`
  position: relative;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: flex;
  justify-content: center;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CircularProgressSVG = (styled.svg`
  transform: rotate(-90deg);
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CircularProgressBackground = (styled.circle<{ strokeWidth: number; color: string }>`
  fill: none;
  stroke: ${props => props.color};
  stroke-width: ${props => props.strokeWidth}px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CircularProgressForeground = (styled.circle<{ strokeWidth: number; color: string; strokeDasharray: number; strokeDashoffset: number }>`
  fill: none;
  stroke: ${props => props.color};
  stroke-width: ${props => props.strokeWidth}px;
  stroke-dasharray: ${props => props.strokeDasharray};
  stroke-dashoffset: ${props => props.strokeDashoffset};
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProgressText = (styled.div<{ fontSize: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: ${props => props.fontSize}px;
  font-weight: bold;
  color: #333;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
